import React from 'react';

export const SkeletonCard = ({ className = '' }) => (
    <div className={`bg-card border border-white/5 rounded-2xl p-6 animate-pulse ${className}`}>
        <div className="flex items-center gap-4 mb-4">
            <div className="w-12 h-12 rounded-xl bg-slate-800"></div>
            <div className="space-y-2">
                <div className="h-4 w-24 bg-slate-800 rounded"></div>
                <div className="h-6 w-32 bg-slate-700 rounded"></div>
            </div>
        </div>
        <div className="space-y-3 mt-6">
            <div className="h-2 w-full bg-slate-800 rounded"></div>
            <div className="h-2 w-4/5 bg-slate-800 rounded"></div>
        </div>
    </div>
);

export const SkeletonTable = ({ rows = 5 }) => (
    <div className="w-full">
        {/* Header rough shape */}
        <div className="flex border-b border-white/10 pb-4 mb-4 gap-4 px-6">
            <div className="h-4 w-1/4 bg-slate-800 rounded animate-pulse"></div>
            <div className="h-4 w-1/4 bg-slate-800 rounded animate-pulse"></div>
            <div className="h-4 w-1/4 bg-slate-800 rounded animate-pulse"></div>
            <div className="h-4 w-1/4 bg-slate-800 rounded animate-pulse"></div>
        </div>
        {/* Rows */}
        <div className="space-y-4">
            {[...Array(rows)].map((_, i) => (
                <div key={i} className="flex items-center gap-4 px-6 py-3 bg-card/50 rounded-xl animate-pulse">
                    <div className="flex items-center gap-3 w-1/4">
                        <div className="w-10 h-10 rounded-full bg-slate-800"></div>
                        <div className="space-y-2 flex-1">
                            <div className="h-3 w-2/3 bg-slate-700 rounded"></div>
                            <div className="h-2 w-1/2 bg-slate-800 rounded"></div>
                        </div>
                    </div>
                    <div className="w-1/4 h-3 bg-slate-800 rounded"></div>
                    <div className="w-1/4 flex gap-2">
                        <div className="w-16 h-6 rounded-full bg-slate-800"></div>
                    </div>
                    <div className="w-1/4 h-3 bg-slate-800 rounded"></div>
                </div>
            ))}
        </div>
    </div>
);

export const SkeletonText = ({ lines = 3, className = '' }) => (
    <div className={`space-y-2 animate-pulse ${className}`}>
        {[...Array(lines)].map((_, i) => (
            <div
                key={i}
                className={`h-3 bg-slate-800 rounded ${i === lines - 1 ? 'w-2/3' : 'w-full'}`}
            ></div>
        ))}
    </div>
);

const Skeleton = {
    Card: SkeletonCard,
    Table: SkeletonTable,
    Text: SkeletonText
};

export default Skeleton;
